import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import moment from "moment";
import { useOrderFlow } from "../../../OrderFlow/OrderFlowProvider/OrderFlowContext";
import { Box, Skeleton } from "@mui/material";
export const CutoffDate = ({ msg, format, align, className, }) => {
    const { store } = useOrderFlow();
    if (typeof store.cart.cutoffDay === "undefined") {
        return _jsx(Skeleton, { variant: "text", height: 20 });
    }
    const cutoffDay = moment(store.cart.cutoffDay);
    if (moment(cutoffDay, format).isValid()) {
        return (_jsx(Box, Object.assign({ className: className, sx: {
                textAlign: align,
                px: 1,
                py: 0,
            } }, { children: msg + " " + cutoffDay.tz(getUserTimezone()).format(format) })));
    }
    return _jsx(_Fragment, {});
};
const getUserTimezone = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone;
};
